const atlasLand: ReadonlyArray<ReadonlyArray<readonly [number, number]>> = [
  [[24, 27]],
  [
    [23, 28],
    [35, 35],
    [44, 46]
  ],
  [
    [13, 16],
    [18, 20],
    [22, 28],
    [44, 50],
    [52, 55]
  ],
  [
    [10, 20],
    [23, 27],
    [35, 58]
  ],
  [
    [4, 20],
    [30, 31],
    [35, 59]
  ],
  [
    [3, 19],
    [35, 60]
  ],
  [
    [8, 19],
    [30, 31],
    [34, 61]
  ],
  [
    [7, 19],
    [30, 31],
    [32, 61]
  ],
  [
    [6, 18],
    [31, 58]
  ],
  [
    [5, 17],
    [30, 57]
  ],
  [
    [5, 16],
    [30, 56],
    [57, 58]
  ],
  [
    [5, 15],
    [28, 55],
    [57, 57]
  ],
  [
    [6, 13],
    [15, 15],
    [27, 55]
  ],
  [
    [7, 12],
    [14, 16],
    [26, 48],
    [50, 55]
  ],
  [
    [9, 13],
    [15, 17],
    [25, 40],
    [41, 47],
    [50, 57]
  ],
  [
    [10, 13],
    [25, 40],
    [44, 46],
    [51, 57]
  ],
  [
    [12, 16],
    [26, 39],
    [51, 58]
  ],
  [
    [14, 20],
    [27, 38],
    [51, 61]
  ],
  [
    [14, 21],
    [28, 38],
    [51, 61]
  ],
  [
    [14, 22],
    [28, 38],
    [52, 60]
  ],
  [
    [14, 22],
    [28, 37],
    [55, 60]
  ],
  [
    [14, 21],
    [29, 37],
    [39, 39],
    [54, 61]
  ],
  [
    [14, 20],
    [29, 36],
    [39, 40],
    [53, 61]
  ],
  [
    [14, 19],
    [30, 35],
    [53, 61]
  ],
  [
    [14, 18],
    [30, 34],
    [53, 60]
  ],
  [
    [13, 17],
    [31, 33],
    [54, 59]
  ],
  [
    [13, 16],
    [57, 59],
    [62, 63]
  ],
  [
    [13, 15],
    [62, 63]
  ],
  [[13, 14]],
  [[13, 14]]
];

export const atlasLive: ReadonlyArray<readonly [number, number]> = [
  [7, 31],
  [7, 33],
  [8, 34],
  [8, 36],
  [9, 32],
  [9, 35],
  [8, 38],
  [9, 38],
  [6, 35],
  [5, 37],
  [6, 37],
  [7, 36],
  [9, 31],
  [10, 31],
  [9, 37],
  [8, 32],
  [7, 10],
  [9, 8],
  [10, 13],
  [12, 9],
  [6, 14],
  [9, 15],
  [19, 17],
  [21, 19],
  [17, 15],
  [15, 11],
  [22, 16],
  [12, 42],
  [13, 45],
  [10, 52],
  [14, 53],
  [10, 57],
  [9, 55],
  [13, 51],
  [18, 53],
  [16, 57],
  [23, 57],
  [21, 60],
  [26, 62],
  [25, 32],
  [15, 31],
  [17, 36],
  [11, 38]
];

export const atlasPipeline: ReadonlyArray<readonly [number, number]> = [
  [12, 43],
  [16, 54],
  [24, 15],
  [11, 36],
  [13, 30]
];

export const atlasPings: ReadonlyArray<readonly [number, number]> = [
  [8, 34],
  [12, 42],
  [19, 17],
  [23, 57]
];

export const atlasCell = 15;

const atlasSpecial = new Set([...atlasLive, ...atlasPipeline].map(([row, column]) => `${row}:${column}`));

export const atlasLandDots = atlasLand.flatMap((spans, row) =>
  spans.flatMap(([start, end]) =>
    Array.from({ length: end - start + 1 }, (_, offset) => [row, start + offset] as const).filter(
      ([dotRow, column]) => !atlasSpecial.has(`${dotRow}:${column}`)
    )
  )
);
